/**
 * Spelling Werkwoorden (SWW) — 24 families, 5 skills
 *
 * Skills: tegenwoordige_tijd (7), verleden_tijd (7), voltooid_deelwoord (5),
 *         bijvoeglijk_naamwoord (2), leenwoorden (3)
 *
 * Split from taxonomyRegistry.ts in R23.
 *
 * LDG Audit (16 mrt 2026): 2 tier-aanpassingen doorgevoerd:
 * - SWW-VT-STERK: M6 (tier 3) → E6 (tier 5) — VT pas na TT-beheersing, Staal/Taalverhaal eind groep 6
 * - SWW-TT-INV-TRICK: E7+ (tier 12) → M7 (tier 9) — standaard M7-stof op CITO-oefentoetsen
 */

import type { FamilyDefinition } from '../types'

export const SWW_FAMILIES: FamilyDefinition[] = [
  // 4.1 Skill: tegenwoordige_tijd (7 families)
  {
    familyId: 'SWW-TT-STAM',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_stam_regel',
    tier: 1,
    levelCode: 'B6',
    description: 'Stam bepalen',
  },
  {
    familyId: 'SWW-TT-ZIJN-HEBBEN',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_zijn_hebben',
    tier: 3,
    levelCode: 'M6',
    description: 'Zijn en hebben (is/heeft) (basis)',
  },
  {
    familyId: 'SWW-TT-INV-JIJ',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_inversie_basis',
    tier: 3,
    levelCode: 'M6',
    description: 'Inversie bij jij',
  },
  {
    familyId: 'SWW-TT-DSTAM',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_d_stam',
    tier: 7,
    levelCode: 'B7',
    description: 'D-stam regel (d+t=dt)',
  },
  {
    familyId: 'SWW-TT-INV-TRICK',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_inversie_complex',
    tier: 9,
    levelCode: 'M7',
    description: 'Inversie complexe gevallen (CITO standaard M7)',
  },
  {
    familyId: 'SWW-TT-MEERVOUD',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_meervoud',
    tier: 2,
    levelCode: 'B6+',
    description: 'Meervoud (wij/jullie/zij)',
  },
  {
    familyId: 'SWW-TT-GEBIEDENDE',
    module: 'SpellingWW',
    skill: 'tegenwoordige_tijd',
    subSkill: 'tt_gebiedende_wijs',
    tier: 5,
    levelCode: 'E6',
    description: 'Gebiedende wijs',
  },
  // 4.2 Skill: verleden_tijd (7 families)
  {
    familyId: 'SWW-VT-STERK',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_sterk',
    tier: 5,
    levelCode: 'E6',
    description: 'Sterke werkwoorden (eind groep 6)',
  },
  {
    familyId: 'SWW-VT-ZIJN-HEBBEN',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_zijn_hebben',
    tier: 7,
    levelCode: 'B7',
    description: 'Zijn en hebben (was/had)',
  },
  {
    familyId: 'SWW-VT-ZWAK-KOF',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_kofschip',
    tier: 5,
    levelCode: 'E6',
    description: "'t Kofschip regel",
  },
  {
    familyId: 'SWW-VT-VZFS',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_vz_fs_wissel',
    tier: 9,
    levelCode: 'M7',
    description: 'V→F / Z→S wissel',
  },
  {
    familyId: 'SWW-VT-ONREGELMATIG',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_onregelmatig',
    tier: 7,
    levelCode: 'B7',
    description: 'Onregelmatige werkwoorden',
  },
  {
    familyId: 'SWW-VT-ZULLEN-KUNNEN',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_hulpwerkwoorden',
    tier: 9,
    levelCode: 'M7',
    description: 'Hulpwerkwoorden (zou/kon)',
  },
  {
    familyId: 'SWW-VT-DUBBEL',
    module: 'SpellingWW',
    skill: 'verleden_tijd',
    subSkill: 'vt_dubbel_dt',
    tier: 11,
    levelCode: 'E7',
    description: 'Dubbele letters (redde/wachtte)',
  },
  // 4.3 Skill: voltooid_deelwoord (5 families)
  {
    familyId: 'SWW-VD-KOF',
    module: 'SpellingWW',
    skill: 'voltooid_deelwoord',
    subSkill: 'vd_kofschip',
    tier: 6,
    levelCode: 'E6+',
    description: 'VD met kofschip (ge+stam+t/d)',
  },
  {
    familyId: 'SWW-VD-STERK',
    module: 'SpellingWW',
    skill: 'voltooid_deelwoord',
    subSkill: 'vd_sterk',
    tier: 7,
    levelCode: 'B7',
    description: 'VD van sterke werkwoorden',
  },
  {
    familyId: 'SWW-VD-ZONDER-GE',
    module: 'SpellingWW',
    skill: 'voltooid_deelwoord',
    subSkill: 'vd_zonder_ge',
    tier: 9,
    levelCode: 'M7',
    description: 'VD zonder ge- (be-, ver-, ont-)',
  },
  {
    familyId: 'SWW-VD-HULPWW',
    module: 'SpellingWW',
    skill: 'voltooid_deelwoord',
    subSkill: 'vd_hulpwerkwoorden',
    tier: 9,
    levelCode: 'M7',
    description: 'VD met hulpwerkwoorden (kerndoel)',
  },
  {
    familyId: 'SWW-VD-HOMOFOON',
    module: 'SpellingWW',
    skill: 'voltooid_deelwoord',
    subSkill: 'vd_pv_verwarring',
    tier: 13,
    levelCode: 'B8',
    description: 'Word/wordt verwarring',
  },
  // 4.4 Skill: bijvoeglijk_naamwoord (2 families)
  {
    familyId: 'SWW-BN-VD-KORT',
    module: 'SpellingWW',
    skill: 'bijvoeglijk_naamwoord',
    subSkill: 'bn_klinker_weglating',
    tier: 11,
    levelCode: 'E7',
    description: 'BN van VD (lange klank)',
  },
  {
    familyId: 'SWW-BN-VD-DUBBEL',
    module: 'SpellingWW',
    skill: 'bijvoeglijk_naamwoord',
    subSkill: 'bn_medeklinker_verd',
    tier: 12,
    levelCode: 'E7+',
    description: 'BN van VD (korte klank)',
  },
  // 4.5 Skill: leenwoorden (3 families)
  {
    familyId: 'SWW-LEEN-ENG-STAM',
    module: 'SpellingWW',
    skill: 'leenwoorden',
    subSkill: 'leen_engels_stam',
    tier: 14,
    levelCode: 'M8',
    description: 'Engelse leenwoorden stam',
  },
  {
    familyId: 'SWW-LEEN-ENG-KOF',
    module: 'SpellingWW',
    skill: 'leenwoorden',
    subSkill: 'leen_engels_kofschip',
    tier: 16,
    levelCode: 'E8+',
    description: 'Engelse leenwoorden kofschip',
  },
  {
    familyId: 'SWW-LEEN-FRANS',
    module: 'SpellingWW',
    skill: 'leenwoorden',
    subSkill: 'leen_frans_werkwoorden',
    tier: 15,
    levelCode: 'E8',
    description: 'Franse leenwoorden (verven)',
  },
]
